import { render, staticRenderFns } from "./TheScrollTop.vue?vue&type=template&id=3325ebcd"
import script from "./TheScrollTop.vue?vue&type=script&lang=ts"
export * from "./TheScrollTop.vue?vue&type=script&lang=ts"
import style0 from "./TheScrollTop.vue?vue&type=style&index=0&id=3325ebcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports